export default "__VITE_ASSET__w1JKLxxT__"